<div id="forgot-password" fxLayout="column">

    <div id="forgot-password-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

        <div id="forgot-password-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

            <div class="logo">
                <!-- <img src="assets/images/logos/fuse.svg"> -->
                <img src="assets/images/logos/tisza-group-black-220.png">
            </div>

            <div class="title">{{'RESET YOUR PASSWORD' | translate}}</div>

            <form name="forgotPasswordForm" [formGroup]="forgotPasswordForm" novalidate>

                <mat-form-field appearance="outline">
                    <mat-label>{{'Email' | translate}}</mat-label>
                    <input matInput formControlName="email">
                    <mat-icon matSuffix class="secondary-text">mail</mat-icon>
                    <!-- <mat-error *ngIf="forgotPasswordForm.get('email').hasError('required')">
                        {{'Email is required' | translate}}
                    </mat-error>
                     <mat-error *ngIf="forgotPasswordForm.get('email').hasError('email')">
                        {{'Please enter a valid email address' | translate}}
                    </mat-error> -->
                    <mat-error *ngIf="checkServerError('email')">{{checkServerError('email')}}</mat-error>
                </mat-form-field>

                <button mat-raised-button class="submit-button text-uppercase" color="accent" aria-label="SEND RESET LINK"
                    [disabled]="forgotPasswordForm.invalid" (click)="resetPassword(forgotPasswordForm)">
                    {{'Reset password' | translate}}
                </button>
            </form>

            <div class="login" fxLayout="row" fxLayoutAlign="center center">
                <a class="link" [routerLink]="'/login'">{{'Go back to login' | translate}}</a>
            </div>

        </div>

    </div>

</div>